// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"898f7ec2","703":"1dc7ef8f","787":"a44cafbd"}[chunkId] + ".chunk.js";
};